module.exports = __webpack_public_path__ + "static/contact-39c6e4a0f26be28575cafe3191705ab4.jpg";